module.exports = __webpack_public_path__ + "static/media/interoperability.9140a5ff.svg";